module.exports = __webpack_public_path__ + "img/kitchen-bkg.c7c7b12a.jpg";